// extracted by mini-css-extract-plugin
module.exports = {"CustomSelect":"CustomSelect_CustomSelect__1sv0l","disabled":"CustomSelect_disabled__1u0UK","separator":"CustomSelect_separator__BRcZp","carousel":"CustomSelect_carousel__332pN"};